import React from "react";
import Box from "@mui/material/Box";

export const Advert = () => (
  <Box sx={{ width: "100%", lineHeight: 0 }}>
    <Box component="img" src="SBD/StrandsBanner.png" alt="StrandsBanner" sx={{ width: "100%", display: "block", objectFit: "cover" }} />
  </Box>
);
